import Vue from "vue"

const eventEmitter: Vue = new Vue()

export default eventEmitter
